import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {Layers, TheRaveLayers} from "../view/TheRaveLayers";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TheRave} from "../TheRave";
import {TimelineLite, TweenLite, Power3} from "gsap";
import {TheRaveSound} from "../sound/TheRaveSound";
import {TheRaveEnhancerReelController} from "../reels/TheRaveEnhancerReelController";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BitmapCountUp} from "../coutup/BitmapCountUp";
import {FontStyleConfig} from "../config/FontConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TheRaveGameMode} from "../gameflow/TheRaveGameMode";

/*
    No Win in FS (via outcome setter)
    [["M1","L1","L1",""],["M2","L2","L2","M2"],["M3","L3","L3","M3"],["M4","L4","L4","M4"],["M5","L5","L5",""]]

    FS with a win on M1 when 3S is triggered
    [["M1","M4","L1",""],["M1","S","L2",""],["M1","S","L3",""],["M2","S","L4",""],["M3","M5","L5",""]]

    FS with No win when 3S is triggered
    [["M1","L1","L3",""],["M2","S","L4",""],["M3","S","L5",""],["M4","S","M4",""],["M5","L2","M5",""]]
 */

export class FreespinOutro extends ContinueScreen {

    private _isPlaying: boolean;
    private _countUp: BitmapCountUp;
    private _introAnimation: PIXI.spine.Spine;

    constructor() {
        super(TheRaveLayers.getLayer(Layers.SCREENS)!);

        const style = FontStyleConfig.COUNT_UP_FS_OUTRO;
        this._countUp = new BitmapCountUp(style);
        this._countUp.visible = false;
        this._countUp.anchor = 0.5;
        this._countUp.position.set(360, 550);
        this._container.addChild(this._countUp);
    }

    private getBelowStakeWinRestriction():boolean {
        if(!TheRave.apiPlugin.gameClientConfiguration.belowStakeWinRestriction) {
            return false;
        }

        const data = TheRave.model.parsedGameData;
        let playedBetValue = data.playedBetValue;
        if(TheRave.model.isRestore || (TheRave.reels[1] && TheRave.reels[1].isBoostActive())) {
            playedBetValue *= 1.2;
        }

        return (data.totalWin / playedBetValue) <= 1;
    }

    public show(onContinueCallBack: () => void) {
        const belowStakeWinRestriction = (this.getBelowStakeWinRestriction() && !TheRave.model.data.wasFeatureBuy) || TheRave.isWinBelowStake();
        this.reset();
        SlotGame.keypadPlugin.hide();
        const data = TheRave.model.parsedGameData,
            currentMode: string = data.mode,
            spinPlayed = data.numberOfFreespinsPlayed,
            countUpDuration = (data.totalWin === 0 || belowStakeWinRestriction) ? 0.01 : 2,
            animationName:string = `${data.mode === TheRaveGameMode.FREESPIN_SUPER?"S":""}FSINTRO`;
        if(this._introAnimation){
            this._container.removeChild(this._introAnimation);
        }
        this._introAnimation = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(animationName));
        this._introAnimation.alpha = 0;
        this._introAnimation.position.set(360, 181);
        this._introAnimation.scale.set(0.5, 0.5);
        this._container.addChild(this._introAnimation);
        this._countUp.maxTextWidth = NolimitApplication.screenBounds.width;
        this._countUp.scale.set(1);
        this._countUp.visible = false;

        const tl = new TimelineLite({paused: true});
        tl.add([
            () => {
                this._isPlaying = true;
                if(data.mode === TheRaveGameMode.FREESPIN_SUPER && TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS)
                {
                    this._introAnimation.state.setAnimation(0, "intro_US_animation", true);
                }else{
                    this._introAnimation.state.setAnimation(0, "animation", true);
                }
                this.visible = true;
                this.onOrientationChanged();

                if(!belowStakeWinRestriction) {
                    TheRaveSound.bgFsEnd(currentMode);
                }
            },
            TweenLite.to(this._introAnimation, {alpha: 1, duration: 0.87, ease: Power3.easeOut}),
           TheRave.fullScreenDimLayer.start()
        ], 0);
        //tl.add(TweenLite.to(this._played, {duration: 0.5, alpha: 1}), 0.5);
        tl.add([
            () => {
                TheRaveSound.switchMusic(
                    {name: TheRaveSound.MAIN_GAME_MUSIC, volume: 0},
                    {name: TheRaveSound.MAIN_GAME_MUSIC, from: 0, to: 1, duration: 2000}
                );
                TheRave.stickySymbol.hideMultiplier();
                TheRave.background.updateEnvironment(TheRave.model.parsedGameData.nextMode);
                TheRave.enhancerReels.forEach((reel:TheRaveEnhancerReelController)=>reel.reelView.isFreeSpin = false);
            },
        ], 0.871);
        TheRaveLayers.getRePositionLayers().forEach((layer:StageLayer|undefined)=>tl.add(TweenLite.to(layer!.position, {
            duration: 0.5,
            y: 0,
            ease: `power3.out`
        }),0.871));
        if (data.totalWin > 0) {
            tl.add([
                ()=>{ this._countUp.y = 550;this._countUp.visible = true;this._countUp.alpha = 1;},
                this._countUp.getCountUpAnimation(0, data.totalWin, {duration:countUpDuration})
            ], 1);
            if(!TheRave.isWinBelowStake()){
                tl.add(()=>TheRaveSound.playSoundEffect(TheRaveSound.FS_OUTRO_COUNTUP_END, 0));
            }

        }
        if(data.totalWin <= 0) {
            this._countUp.visible = true;
            this._countUp.getCountUpAnimation(0, 0, {duration:0});
            this._countUp.text = "0.00";
            this._countUp.scale.set(0.7,0.7);
            this._countUp.y = 550;
        }
        tl.add(() => super.show(onContinueCallBack));
        tl.play(0);
    }

    public onOrientationChanged(): void {
        if (!this._isPlaying) {
            return;
        }
        this._countUp.maxTextWidth = NolimitApplication.screenBounds.width;
        this._countUp.updateCountUpTextPivot();
        super.onOrientationChanged();
    }

    private reset(): void {}

    protected close(): TimelineLite {
        const tl = super.close();
        tl.add(() => {
            TheRave.fullScreenDimLayer.stop();
            TheRave.enhancerReels.forEach((reel:TheRaveEnhancerReelController)=>{
                reel.reelView.hide();
            });
            if(this._introAnimation){
                this._introAnimation.state.setEmptyAnimation(0,0);
                this._container.removeChild(this._introAnimation);
            }
        }, 0);
        if(this._countUp.visible) {
            tl.add(TweenLite.to(this._countUp, {duration : 0.2, alpha : 0, y : -100, ease : `power2.in`}), 0); // stay a short while after count up.
            tl.add(() => {this._countUp.y = -200;
                this._countUp.visible = false;
                this.visible = false});
        }
        this._isPlaying = false;
        return tl;
    }
}